import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  loginSuccess,
  logout,
  clearRedirectUrl,
} from "../store/action/authAction";
import { supabase } from "../supabaseClient";
import { Auth } from "@supabase/auth-ui-react";
import { ThemeSupa } from "@supabase/auth-ui-shared";
import { IoClose } from "react-icons/io5";
import { useNavigate } from "react-router-dom";
import "./signin.css";

export default function SignIn({ closeLogin }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const redirectUrl = useSelector((state) => state.auth.redirectUrl);

  useEffect(() => {
    const checkSessionAndRedirect = async () => {
      try {
        const {
          data: { session },
          error,
        } = await supabase.auth.getSession();

        if (error) throw error;

        if (session && redirectUrl) {
          const isInternalUrl =
            new URL(redirectUrl).origin === window.location.origin;

          if (isInternalUrl) {
            navigate(redirectUrl);
          } else {
            navigate("/");
          }

          dispatch(clearRedirectUrl());
          closeLogin();
        }
      } catch (error) {
        console.error("Redirect error:", error);
        dispatch(clearRedirectUrl());
        closeLogin();
      }
    };

    checkSessionAndRedirect();
  }, [dispatch, navigate, redirectUrl, closeLogin]);

  useEffect(() => {
    const {
      data: { subscription },
    } = supabase.auth.onAuthStateChange((event, session) => {
      if (session) {
        dispatch(loginSuccess(session.user));
      } else {
        dispatch(logout());
      }
    });

    return () => subscription?.unsubscribe();
  }, [dispatch]);

  return (
    <div className="signin-container">
      <div className="signin-box">
        <h2 className="signin-title">Sign In</h2>
        <Auth
          supabaseClient={supabase}
          appearance={{ theme: ThemeSupa }}
          providers={["google", "facebook"]}
          redirectTo={window.location.origin + (redirectUrl || "")}
        />
        <button className="close-button" onClick={closeLogin}>
          <IoClose size="25" />
        </button>
      </div>
    </div>
  );
}
